import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdDupesOptions } from '@onefootprint/fetch-dashboard';
import { useQuery } from '@tanstack/react-query';
const useEntityDuplicateData = (id, timestamp, t0) => {
  const $ = _c(6);
  const enabled = t0 === undefined ? true : t0;
  let t1;
  if ($[0] !== id || $[1] !== timestamp) {
    t1 = getEntitiesByFpIdDupesOptions({
      path: {
        fpId: id
      },
      query: {
        timestamp
      }
    });
    $[0] = id;
    $[1] = timestamp;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = !!id && enabled;
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = {
      ...t1,
      enabled: t2
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return useQuery(t3);
};
export default useEntityDuplicateData;